export const TIMEOUT = 300;
export const MIN_LENGTH = 3;
